/**
 * Header decoration/icon for a preference type category.
 *
 * Belongs here: header SVG or fund list UI.
 * Does not belong here: questionnaire flow.
 */
import { formatRupeeLabel } from '../../../../plans-v4/display-values/lumpsumPlanAmount'
import { mfLogoBaseUrl } from '../../../../../../env'
import type { QuestionOptionFundItem } from '../../../shared/types/questionnaire.types'

export interface FundListItemProps {
  fund: QuestionOptionFundItem
  className?: string
  truncateName?: boolean
}

export function FundListItem({ fund, className = '', truncateName = true }: FundListItemProps) {
  return (
    <div
      className={`flex min-w-0 flex-1 gap-3 ${truncateName ? 'items-center' : 'items-start py-4'} ${className}`.trim()}
    >
      <div className={`shrink-0 overflow-hidden rounded bg-white ${truncateName ? 'h-8 w-8' : 'h-10 w-10'}`}>
        <img
          src={`${mfLogoBaseUrl}${fund.companyLogoUrl ?? ''}`}
          alt=""
          className="h-full w-full object-contain"
          onError={(event) => {
            const target = event?.target as HTMLImageElement
            target.style.display = 'none'
          }}
        />
      </div>
      <div className="min-w-0 flex-1">
        <p
          className={`text-[#232323] ${truncateName ? 'truncate text-[12px] font-[500] leading-[150%]' : 'text-[13px] font-[400] leading-[150%]'}`}
        >
          {fund?.fundName ?? ''}
        </p>
        {fund?.currentValue != null ? (
          <p
            className={`mt-0.5 font-[400] text-[#6A6E6E] ${truncateName ? 'text-[11px]' : 'text-[13px] leading-[150%]'}`}
          >
            {formatRupeeLabel({ rawAmount: fund.currentValue })}
          </p>
        ) : null}
      </div>
    </div>
  )
}
